
import { Component, Vue } from "vue-property-decorator";
import {
  apiAuthPlatformGroupAdd,
  apiAuthPlatformGroupEdit,
  apiAuthPlatformGroupDetail,
  apiAuthPlatformRuleAll,
} from "@/api/permissions";
import { PageMode } from "@/utils/type";

@Component
export default class RoleEdit extends Vue {
  /** S Data **/
  mode: string = PageMode.ADD; // 当前页面【add: 添加角色 | edit: 编辑角色】
  identity: number | null = null; // 当前编辑用户的身份ID  valid: mode = 'edit'

  // 表单数据
  form: any = {
    name: "",
    auth_keys: [],
    auth_keys_parents: [],
    desc: "",
    pid: "",
  };

  // 权限树
  permissionsTree: any[] = [];

  // 表单验证
  rules: object = {
    name: [{ required: true, message: "必填项不可为空", trigger: "blur" }],
  };

  defaultKeys: any = [];
  /** E Data **/

  /** S Methods **/

  // 递归找到父节点并设置父节点为选中状态
  getParentNodes(node: any, treeData: any) {
    if (!node) return;

    // 查找父节点
    const findParent = (currentNode: any, parentTree: any) => {
      for (const item of parentTree) {
        if (
          item.children &&
          item.children.some((child: any) => child.id === currentNode.id)
        ) {
          return item;
        }
        if (item.children) {
          const result: any = findParent(currentNode, item.children);
          if (result) {
            return result;
          }
        }
      }
      return null;
    };

    let parentNode = findParent(node, treeData);
    while (parentNode) {
      const treeNode = this.$refs.permissionsTree as any;
      treeNode.setChecked(parentNode, true, false); // 设置父节点为选中状态，不触发事件
      parentNode = findParent(parentNode, treeData);
    }
  }

  // 表单提交
  submitForm(formName: string) {
    const ref = this.$refs[formName] as HTMLFormElement;
    ref.validate((valid: boolean) => {
      if (!valid) {
        return this.$message.error("请完善信息");
      }
      let treeNode = this.$refs.permissionsTree as any;
      const auth_keys = treeNode
        .getCheckedNodes()
        .map((item: any) => item.id)
        .filter((item: any) => item != 0);
      const half_auth_keys = treeNode
        .getHalfCheckedNodes()
        .map((item: any) => item.id)
        .filter((item: any) => item != 0);

      this.form.auth_keys = [...new Set([...auth_keys, ...half_auth_keys])];
      this.form.auth_keys_parents = this.form.auth_keys;
      // 处理权限数据
      // 请求发送
      switch (this.mode) {
        case PageMode.ADD:
          return this.handleRoleAdd();
        case PageMode.EDIT:
          return this.handleRoleEdit();
      }
    });
  }

  // 添加角色
  handleRoleAdd() {
    const params = this.form;
    apiAuthPlatformGroupAdd(params)
      .then(() => {
        setTimeout(() => this.$router.go(-1), 500);
      })
      .catch(() => {});
  }

  // 编辑角色
  handleRoleEdit() {
    const params = this.form;
    const id: number = this.identity as number;
    apiAuthPlatformGroupEdit({ ...params, id })
      .then(() => {
        setTimeout(() => this.$router.go(-1), 500);
      })
      .catch(() => {});
  }

  // 初始化表单数据: 角色编辑
  initFormDataForRoleEdit() {
    const id: number = this.identity as number;
    apiAuthPlatformGroupDetail({ id })
      .then((res) => {
        Object.keys(res).map((item) => {
          this.$set(this.form, item, res[item]);
        });
        const auth_keys = new Set([
          ...res.auth_keys,
          ...res.auth_keys_parents.map(Number),
        ]);
        this.defaultKeys = this.getChildrenNodes(
          auth_keys,
          this.permissionsTree,
        );
      })
      .catch(() => {});
  }

  // 递归获取所有的子节点
  getChildrenNodes(node: any, treeData: any) {
    // 优化思路：使用递归函数遍历树结构，将符合条件的叶子节点添加到结果数组中
    const collectLeafNodes = (tree: any, targetSet: any, result: any) => {
      for (const item of tree) {
        if (!item.children || item.children.length === 0) {
          if (targetSet.has(item.id)) {
            result.push(item.id);
          }
        } else {
          collectLeafNodes(item.children, targetSet, result);
        }
      }
    };
    const children: any[] = [];
    collectLeafNodes(treeData, node, children);
    return children;
  }

  // 获取权限菜单
  getAuthMenu() {
    return new Promise((resolve, reject) => {
      apiAuthPlatformRuleAll({ type: "" }).then((res) => {
        this.permissionsTree = [
          { id: 0, name: "功能菜单", en_name: "", children: res },
        ];
        resolve(res);
      });
    });
  }

  getAuthKey(arr: any[] = this.permissionsTree) {
    let idArray: number[] = [];
    const traverseArray = (array: any[]) => {
      for (const item of array) {
        if (item.id) {
          idArray.push(item.id);
        }
        if (item.children && item.children.length > 0) {
          traverseArray(item.children);
        }
      }
    };
    traverseArray(arr);
    return idArray;
  }
  /** E Methods **/
  /** S Life Cycle **/
  async created() {
    const query: any = this.$route.query;
    if (query.mode) {
      this.mode = query.mode;
    }
    await this.getAuthMenu();
    if (this.mode === PageMode.EDIT) {
      this.identity = query.id * 1;
      this.initFormDataForRoleEdit();
    }
  }

  /** S Life Cycle **/
}
